import { ADJUST_REASONS_BY_ACTION } from './adjust-reasons-by-action.js';
export function isAdjustReasonAllowed(action, reasonId) {
    return ADJUST_REASONS_BY_ACTION[action].includes(reasonId);
}
//# sourceMappingURL=is-adjust-reason-allowed.js.map